{
  "version": "REF_V1",
  "engineVersion": "E1",
  "attributionVersion": "A1",
  "featureNames": [
    "logScan",
    "logCands",
    "logYield",
    "prox",
    "sameUnit",
    "unitRecency",
    "sigRecency",
    "fill",
    "subsumed",
    "logLive"
  ],
  "observations": 10127,
  "logLikPerObs": -1.313489210850321,
  "reference": {
    "theta": -0.9063566579042525,
    "motor": {
      "interceptMs": 713.9348152304799,
      "perCellMs": 76.48062904895811
    }
  },
  "playerObservations": {
    "andrea": 3312,
    "giby": 3056,
    "stephanie": 1688,
    "jamie": 968,
    "veronica": 578,
    "tek": 512,
    "camrie": 13
  },
  "model": {
    "sigKeys": [
      "R2/col/2",
      "R2/col/3",
      "R2/row/2",
      "R2/row/3",
      "R3/col/2",
      "R3/col/3",
      "R3/col/4+",
      "R3/row/2",
      "R3/row/3",
      "R3/row/4+",
      "R4/col/2",
      "R4/col/3",
      "R4/col/4+",
      "R4/row/2",
      "R4/row/3",
      "R4/row/4+",
      "R5/cols/2",
      "R5/cols/3",
      "R5/cols/4+",
      "R5/rows/2",
      "R5/rows/3",
      "R5/rows/4+",
      "R6/cols/2",
      "R6/cols/3",
      "R6/cols/4+",
      "R6/rows/2",
      "R6/rows/3",
      "R6/rows/4+",
      "R7/Lshape/3",
      "R7/adj2/2",
      "R7/line/3",
      "R7/pair/2",
      "R7/spread/3",
      "R7/spread/4+",
      "R8/col/1",
      "R8/region/1",
      "R8/row/1",
      "R9/colorxcol+ovl/1",
      "R9/colorxcol+ovl/2",
      "R9/colorxcol+ovl/3",
      "R9/colorxcol+ovl/4+",
      "R9/colorxcol/1",
      "R9/colorxcol/2",
      "R9/colorxcol/3",
      "R9/colorxcol/4+",
      "R9/colorxcolor/1",
      "R9/colorxcolor/2",
      "R9/colorxcolor/3",
      "R9/colorxcolor/4+",
      "R9/colorxrow+ovl/1",
      "R9/colorxrow+ovl/2",
      "R9/colorxrow+ovl/3",
      "R9/colorxrow+ovl/4+",
      "R9/colorxrow/1",
      "R9/colorxrow/2",
      "R9/colorxrow/3",
      "R9/colorxrow/4+",
      "R9/colxcol/1",
      "R9/colxcol/2",
      "R9/colxcol/3",
      "R9/colxcol/4+",
      "R9/rowxcol+ovl/1",
      "R9/rowxcol+ovl/2",
      "R9/rowxcol+ovl/3",
      "R9/rowxcol+ovl/4+",
      "R9/rowxcol/1",
      "R9/rowxcol/2",
      "R9/rowxcol/3",
      "R9/rowxcol/4+",
      "R9/rowxrow/1",
      "R9/rowxrow/2",
      "R9/rowxrow/3",
      "R9/rowxrow/4+"
    ],
    "alpha": [
      -1.8664767335537786,
      -2.767646475393029,
      -2.1636003576141367,
      -2.532455601242459,
      3.9269086323342908,
      4.172179291495774,
      3.8738131947994123,
      4.514840853829305,
      4.481829668798571,
      4.578347629283528,
      2.653399539973739,
      2.589707194713252,
      2.912211003021638,
      2.3756917557792536,
      1.9041963000331201,
      3.425899638204375,
      0.4550034560149025,
      0.14407642704886625,
      -2.80143654694089,
      0.8804996363019693,
      -0.6514908035032464,
      -1.1045489651875184,
      0.22254072811329484,
      0.27550783341830415,
      -0.30517379541609624,
      -1.1717909730554896,
      -1.1441507617587265,
      -0.7307585348349216,
      1.4951658717169298,
      0.7719059826051111,
      -2.4981504272633965,
      -3.142956500097747,
      -3.3788527370923886,
      -3.1605937082398103,
      2.488092115266909,
      3.3299822293288175,
      2.6374047257312614,
      -3.344336499922905,
      -2.061192469138938,
      -3.523634904913388,
      -1.9118845540251395,
      -3.433463556252808,
      -0.810125188844242,
      -1.7959858235939536,
      -0.9010930688651284,
      -5.5035731244532,
      0.42518834465428007,
      0.053588672107486995,
      -0.38749363181024016,
      -3.4047295759999785,
      -0.04187550160007252,
      -0.9654468682959869,
      -2.152918179140759,
      -4.572177610051125,
      -0.6190446751613087,
      -2.190576466193398,
      -1.1443175736786564,
      -0.4102934641086447,
      -1.2281031944739709,
      0.08988727412070298,
      -0.46793894263808905,
      1.8501518742308252,
      -3.286793250826892,
      0.38499059963818283,
      -1.470429451108242,
      -4.550213381243771,
      -0.9739143357505062,
      -2.529492918452791,
      -2.209706222413972,
      -3.6643041113230486,
      -2.2722731927073916,
      -0.31037794985889267,
      -0.2770702618936082
    ],
    "beta": [
      -0.673991434011351,
      -0.20010057294394515,
      0.9691631624142457,
      0.6309012708499243,
      1.0253475329671726,
      -0.42614555965528195,
      0.7027243173933535,
      -0.9776662545345756,
      -2.5281634928835586,
      -0.32968990434672324
    ],
    "players": {
      "andrea": {
        "theta": -0.9700117125729252,
        "delta": [
          0.04020472216696654,
          -0.006346920603650171,
          -0.001909264810348092,
          -0.0011588120028314516,
          -0.38775109078420694,
          -0.7020647181400139,
          -0.0749302319177953,
          -0.3746635851968577,
          -1.1422991761045331,
          -0.43711462436873977,
          0.5137236065891831,
          -0.2353164826222748,
          -0.026985083670549137,
          -0.3149599114447498,
          0.09927777454774622,
          0.6947505515166063,
          -0.12291838304515675,
          0.09529618507485428,
          0.11022176910500774,
          -0.7691934278930536,
          0.025386438677537367,
          0.05733293036345476,
          -0.6387010329352795,
          -0.029640387859403088,
          0.07890255579676377,
          -0.6198961474805498,
          0.47044774736731526,
          0.13679181567651097,
          2.4026048632886536,
          1.1119317333484284,
          0.018446127306166904,
          -0.004195973589904063,
          -0.0008200973264065814,
          -0.004619697474276317,
          -0.3872209662633161,
          -0.8132604002017831,
          -0.7083297306527541,
          -0.008393892678050754,
          0.004534211199283237,
          -0.027051925462880558,
          -0.11212933002255564,
          -0.009843586536464624,
          -0.656831471500406,
          0.16878862113837478,
          0.7628333122009296,
          -0.004243979499242912,
          0.31040356493256854,
          0.7239366061157224,
          0.3682593895374995,
          -0.006775933851217653,
          -0.10845923888065018,
          -0.04114072419644092,
          -0.20336606461498646,
          -0.013231893166411537,
          -0.11988985450446454,
          -0.06038159266975199,
          0.8183274060430489,
          -0.06636906692095483,
          -0.29564887530513034,
          -0.27403167749249324,
          -0.16106124555699036,
          -0.09898812129564435,
          -0.02811608774853205,
          -0.008586012973198125,
          0.24376072801135135,
          -0.009720082032253233,
          -0.009106706064536145,
          -0.26377710365416046,
          -0.16793283471304746,
          -0.009802512086495638,
          -0.034895063340476005,
          -0.5666429578040831,
          -0.6731447405420001
        ],
        "motor": {
          "interceptMs": 250,
          "perCellMs": 120
        }
      },
      "giby": {
        "theta": -1.1373099712368626,
        "delta": [
          -0.057819191056988885,
          -0.003175625584408023,
          -0.005919663189475142,
          0.0002451413531584967,
          -0.37185697624000397,
          -0.576696322481349,
          -0.09502088497341311,
          -1.0690798236799313,
          -0.7950262056867071,
          -0.09027658643007343,
          -0.4096212753980816,
          0.1942730618356375,
          0.35539358700681795,
          0.41392830695307714,
          0.25321240819383745,
          0.3440185525289484,
          -0.16552496403395686,
          0.4064720512341411,
          -0.09850731093089568,
          -0.16239533230117303,
          -0.1378885825095109,
          0.0022551409840162527,
          0.44330710934626316,
          -1.0021304841629637,
          0.053959101030772755,
          0.5699466544196283,
          -0.4016605470143033,
          -0.14269967474942133,
          -0.5569713121253299,
          -0.005024075827372655,
          -0.010151065488540056,
          -0.004203130992796067,
          -0.006355404258469984,
          -0.03948724906781574,
          -0.4886576863334321,
          0.9630563759661606,
          -0.4205642239355483,
          -0.0035656362347172526,
          0.00900437276304982,
          -0.11220914250411396,
          -0.017339490691016365,
          -0.018089002552055672,
          0.06167954709034253,
          -0.05479577288223691,
          0.32693184327779873,
          -0.013195137363477577,
          0.2640469596630492,
          0.5280185422275322,
          0.5616059126958299,
          -0.004867085630949799,
          0.25478920812980094,
          0.2729652537241355,
          -0.09380974269776955,
          -0.005888560075687211,
          0.5700166274790539,
          -0.1737099534281138,
          -0.013775971852472684,
          -0.008900971181104111,
          0.08039000543168087,
          -0.10178702874527483,
          -0.4117694566916728,
          -0.010212625329631533,
          -0.004557016739025097,
          -0.05433614180471395,
          -0.5011450609842036,
          -0.017642400499359136,
          -0.2531026769284754,
          0.0920058353534369,
          0.0020895498272930036,
          -0.0009896324967533499,
          -0.02280640995467247,
          -0.35428643911986346,
          -0.05234783073336614
        ],
        "motor": {
          "interceptMs": 1270.1648557502235,
          "perCellMs": 8.807922129266267
        }
      },
      "stephanie": {
        "theta": -0.8050998966173872,
        "delta": [
          -0.0063401732355000025,
          -0.00606572380623585,
          -0.005550461588434839,
          -0.005720674081110521,
          0.37290383208660677,
          0.8605145601911276,
          -0.018597859394747156,
          0.98386358517378,
          0.4836059038528991,
          -0.5695977404586688,
          -0.3388360228493316,
          0.14512235455074446,
          -1.0422918276823394,
          -0.10297158501247397,
          -0.2659814462358792,
          -0.9727593029825641,
          0.567716765244766,
          -0.6226963780426829,
          -0.02920027581214767,
          0.37712451117536244,
          -0.2961902955804997,
          -0.04336820729758447,
          0.007336349151084904,
          0.5106081032570458,
          -0.28337916953113745,
          -0.22335191927361983,
          -0.2485251761548314,
          0.2572195601076504,
          -0.9333418908461407,
          -0.3536487221899338,
          -0.019714337238222385,
          -0.003984743809020058,
          -0.00661056405626011,
          -0.03193284252206017,
          0.3495603695960148,
          0.3717063816069329,
          0.2203317835980551,
          -0.0003254371495967438,
          -0.01147298869232504,
          -0.010786523658092165,
          -0.2062597109469827,
          -0.007375561722632499,
          -0.1878937344167392,
          -0.12265165862258778,
          -0.22153831322911247,
          -0.0007468432665739432,
          0.6621754383114005,
          -0.18462192800151336,
          0.004726299198281113,
          -0.0010435417657394337,
          -0.12264365286003576,
          -0.07146226346072096,
          -0.11155411787227494,
          -0.003525003882067281,
          0.011933520710387618,
          0.13970439589821967,
          -0.38095982244371723,
          -0.023505143539361346,
          0.18153609299708176,
          0.8082574679066037,
          -0.17516469920946012,
          -0.005802078336492001,
          -0.009171560628650134,
          0.30682227936007017,
          -0.3589308388171623,
          -0.0014470807587129509,
          0.07368823169720863,
          -0.048455832163819476,
          -0.16647498001484295,
          -0.0007531114875352015,
          -0.0136089384853662,
          0.4528220625702992,
          -0.07155673951042117
        ],
        "motor": {
          "interceptMs": 250,
          "perCellMs": 120
        }
      },
      "jamie": {
        "theta": -0.6417387173146936,
        "delta": [
          -0.0073680164975204075,
          -0.0012261875384069409,
          -0.0059292618327154815,
          -0.0037685904070710436,
          -0.5859365080719267,
          0.047273748891484786,
          -0.6161015661550062,
          -0.5475769131861477,
          -0.3023214677338017,
          0.06016831089169411,
          -0.0867434860452302,
          -0.07055953404711227,
          -0.045114738961787096,
          -0.05698560017122423,
          -0.0032131134142215742,
          -0.3187228378257494,
          -0.1318593298030673,
          -0.0642390554333812,
          0.00022649090139675363,
          0.17321967349092435,
          -0.028928778509667262,
          0.11087239671766896,
          0.3949352435589033,
          -0.007774234493966899,
          0.3070733023293708,
          0.24717179745075332,
          0.10008611093685912,
          0.1536496531063308,
          -0.3161341321823043,
          -0.5171541323779254,
          -0.010238148469801304,
          -0.00005232749127897001,
          -0.000044832935961069824,
          -0.007732827157932243,
          0.33323802492668403,
          0.12913107864718643,
          0.6962574716239094,
          0.0010621384141868563,
          -0.03979775822791146,
          -0.0014214179416045846,
          0.0029795872558607433,
          0.023229413304174423,
          0.06776033940424228,
          -0.05203515425703666,
          -0.490959860730981,
          0.001031130774262405,
          -0.15805560462178075,
          -0.6125619341426177,
          -0.25666404637336365,
          -0.00006642550477863038,
          0.07848922995328143,
          -0.0709230485940859,
          -0.09556688997042523,
          -0.001421080432274027,
          0.28532722256236953,
          -0.14522608572499687,
          -0.46717935138634575,
          0.1573532238881598,
          0.0003592419770219193,
          0.06308226109803505,
          1.3618343559233874,
          0.15204316189589093,
          -0.016203399697345394,
          -0.3075537643389333,
          0.03510616396664724,
          0.0001236567959958364,
          0.1280290116461103,
          0.06547679500295166,
          0.05506589548508804,
          0.0009378556911939718,
          0.0731124297846761,
          0.1904246394727343,
          0.7611739266177644
        ],
        "motor": {
          "interceptMs": 1149.9737244059104,
          "perCellMs": 46.84777870000793
        }
      },
      "veronica": {
        "theta": -0.39013265929715957,
        "delta": [
          -0.016792121721337247,
          -0.0013928928221648995,
          -0.020691699723675457,
          -0.005535360421203826,
          1.3246684604858314,
          0.6038658012402534,
          0.447013452736747,
          1.3005546706915527,
          1.664387029348296,
          1.044444062552971,
          0.041020683103719306,
          0.09034185351956882,
          -0.44844112901720773,
          0.13768852096308132,
          0.012578194090299045,
          0.24352461742509882,
          0.3549895941169659,
          0.45634693995882314,
          -0.0021364323558250306,
          0.3561133645955807,
          0.21174299103866787,
          -0.005229079145583443,
          -0.09704770562817204,
          0.12942173455462772,
          -0.07430534976161964,
          -0.1288427182625831,
          0.00322790780304641,
          -0.31864835353272114,
          -0.44010720378639806,
          -0.5643017348839774,
          -0.005391411938745129,
          -0.00045461970142368727,
          -0.0004399791512276657,
          -0.012185718707566066,
          -0.05035318976939478,
          0.06280688948934547,
          0.169732683632926,
          -0.000031975841635295966,
          -0.023350122378964628,
          -0.0029897177016099965,
          -0.10090916749085221,
          -0.0063313500170124855,
          -0.021959866410168647,
          0.04266803822246841,
          -1.0979779773324643,
          -0.0000560747669550861,
          -1.1373237085051118,
          -0.333020885075602,
          -0.7629730900710512,
          -0.0007699275366504387,
          -0.09910181809906615,
          -0.05540860036885067,
          -0.040689968057106805,
          -0.00038203577085878807,
          -0.7045536615117065,
          -0.1788824476353934,
          -0.5724402516014963,
          -0.05951044915823667,
          -0.2625694023244864,
          0.38331667641270223,
          -1.0380429860492166,
          -0.0028216392725375623,
          -0.005471579023004074,
          -0.0907106287501303,
          0.029525448362831126,
          -0.0031439528036971125,
          0.2757301040648824,
          -0.07017216165728628,
          -0.1766248605931731,
          -0.0006704766496494284,
          -0.009595619476092098,
          -0.10209986822493403,
          -0.4063526183370474
        ],
        "motor": {
          "interceptMs": 1473.337585394035,
          "perCellMs": 66.16085900731227
        }
      },
      "tek": {
        "theta": -0.5676426593732472,
        "delta": [
          0.007041008402229923,
          -0.0025554258929522096,
          0.010123426001301434,
          -0.0028173285440396562,
          -0.4775976997006,
          -0.22077883499592793,
          0.3665442648842267,
          -0.18426026343974092,
          0.10492290379732547,
          0.0048755580308377485,
          0.28910082016577837,
          -0.11513345893060613,
          1.2037633860994241,
          -0.06598428438267927,
          -0.09913303349173627,
          0.04171566847409642,
          -0.5405316106262141,
          -0.29625056825339496,
          -0.0022113364203945225,
          -0.02269990280066752,
          0.19761418865058192,
          -0.15650484545069643,
          -0.1203245601561028,
          0.2955302905760285,
          -0.11272688468803511,
          0.11817062628765664,
          0.057595503398423294,
          -0.10724244533482494,
          -0.12295684842697137,
          0.39007410488216093,
          -0.004830781605459726,
          -0.0019428365152187811,
          -0.003899799796032022,
          -0.016399500685663666,
          0.2632070816692758,
          -0.3249036813779081,
          -0.09205747717943802,
          -0.0016102586331503159,
          0.006630769092577224,
          -0.03708765975038922,
          -0.011284168927414864,
          -0.0022142446043079346,
          0.69674459327479,
          -0.18945016317386276,
          -0.09554385785212643,
          -0.00023780725757382992,
          -0.09171192936068664,
          -0.3106121502210854,
          -0.5092364112679687,
          -0.000427671610622864,
          0.03964509809640123,
          -0.0013936157306831914,
          -0.006119305828116891,
          -0.0004987124379670261,
          -0.16161363791679095,
          0.045706088160201594,
          -0.3328888178402296,
          0,
          0.32197801064678466,
          -0.9342242874500664,
          0.27163763926203927,
          -0.029668404784321305,
          0.0003944064654234442,
          0.20137480275980876,
          0.10062675609018291,
          -0.0005167806928653478,
          -0.12571041087888654,
          -0.05178618201676526,
          -0.027557707264512416,
          -0.0000559341805200133,
          0.017211070089333484,
          0.34972444995625135,
          0.3933426831615175
        ],
        "motor": {
          "interceptMs": 250,
          "perCellMs": 120
        }
      },
      "camrie": {
        "theta": 0.45889323604984367,
        "delta": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "motor": {
          "interceptMs": 433.10654490106543,
          "perCellMs": 197.89954337899545
        }
      }
    }
  }
}